import { render, staticRenderFns } from "./reporting-data-table.vue?vue&type=template&id=1c4526d0&scoped=true&"
import script from "./reporting-data-table.vue?vue&type=script&lang=js&"
export * from "./reporting-data-table.vue?vue&type=script&lang=js&"
import style0 from "./reporting-data-table.vue?vue&type=style&index=0&id=1c4526d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4526d0",
  null
  
)

export default component.exports